import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "slug"]

  connect() {
    // Lock auto-gen if slug already has a value (editing existing record)
    this._slugManuallyEdited = this.slugTarget.value.length > 0
  }

  nameChanged(event) {
    if (this._slugManuallyEdited) return
    this.slugTarget.value = this._toSlug(event.target.value)
  }

  slugChanged() {
    // Once user manually edits slug, stop auto-generating
    this._slugManuallyEdited = true
  }

  _toSlug(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .substring(0, 80)
  }
}
